// extracted by mini-css-extract-plugin
export default {"label":"Label_label__S7BLo","hover":"Label_hover__b+7Yi","disabled":"Label_disabled__up9GR"};